import { render } from "./PartsFaqLink.vue?vue&type=template&id=abe34b66&scoped=true"
import script from "./PartsFaqLink.vue?vue&type=script&lang=js"
export * from "./PartsFaqLink.vue?vue&type=script&lang=js"

import "./PartsFaqLink.vue?vue&type=style&index=0&id=abe34b66&scoped=true&lang=css"

import exportComponent from "/Users/maru/Desktop/東野材木/hojokin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abe34b66"]])

export default __exports__